<template>
    <fieldset>
        <!-- Address Fields -->
        <h3 v-show="model.public_id" class="form-heading">{{ trans('product') }}</h3>
        <txt label="product_key" v-model="model.product_key"></txt>
        <div class="form-group">
            <label class="control-label">{{ trans('product_key') }}</label>
            <textarea class="form-control" v-model="model.notes" rows="20"></textarea>
        </div>

        <div class="form-group" :class="{'input-group': taxRate }">
            <label for="XXXXX" class="control-label">Cost</label>
            <input ref="input" class="form-control" id="XXXXXX" type="text" name="XXXXXX" v-model="cost"  aria-describedby="append-XXXXXX" >
            <span v-if="taxRate" class="input-group-addon" id="append-">
                <div id="primaryActions" style="text-align:left" class="btn-group dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
                        {{ taxname }}
                        <span class="caret"></span></button>
                    <ul class="dropdown-menu">
                        <li><a @click.prevent="toggleTax(true)">with Tax</a></li>
                        <li><a @click.prevent="toggleTax(false)">without Tax</a></li>
                    </ul>
                </div>
            </span>
        </div>
        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
    </fieldset>
</template>

<script>
    export default {
        components: {
            'txtarea': require('../../components/form/textarea.vue').default
        },
        data: function() {
            return {
                taxRate: window.TAX_RATE,
                tax: true,
                cost: 0,
                model: {
                    public_id: 0,
                    product_key: '',
                    notes: '',
                    cost: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('productSubmit', this.store);
            this.$eventHub.$on('setProduct', this.setProduct);
        },
        computed: {
            taxname() {
                return (this.tax) ? 'with tax' : 'without tax';
            }
        },
        methods: {
            toggleTax(state) {
                this.tax = state;
            },
            store() {
                this.model.cost = this.cost;
                if (this.tax && this.taxRate) {
                    this.model.cost = (this.cost / this.taxRate).toFixed(4);
                }
                this.$store('/api/product/store', this.model);
            },
            setProduct(data) {
                this.model = this.$setData(data, this.model);
                this.cost = this.model.cost;
                if (this.tax && this.taxRate) {
                    this.cost = (this.cost * this.taxRate).toFixed(4);
                }
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('productSubmit', this.store);
            this.$eventHub.$off('setProduct', this.setProduct);
        }
    }
</script>
